import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MPHDefault = _resolveComponent("MPHDefault")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    transparent: _ctx.transparent,
    "transparent-external": _ctx.transparentExternal,
    "external-background-color": _ctx.externalBackgroundColor,
    loading: _ctx.loading,
    width: _ctx.width,
    "close-on-external-click": _ctx.closeOnExternalClick,
    "full-screen": _ctx.fullScreen,
    "pseudo-full-screen": _ctx.pseudoFullScreen,
    "max-height-content": _ctx.maxHeightContent
  }, _createSlots({
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, 'content-' + _ctx.currentPage, {}, undefined, true)
    ]),
    footer: _withCtx(() => [
      (_ctx.displayNavigation && !_ctx.$slots['footer-' + _ctx.currentPage])
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "ma-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomButton, {
                        level: _ctx.$enums.ButtonLevels.Secondary,
                        text: _ctx.currentPage > 0 ? 'Previous' : 'Cancel',
                        class: "mr-2",
                        onClick: _ctx.goToPreviousPage
                      }, null, 8, ["level", "text", "onClick"]),
                      (_ctx.currentPage < _ctx.nbPages - 1)
                        ? (_openBlock(), _createBlock(_component_CustomButton, {
                            key: 0,
                            class: "ml-auto",
                            level: _ctx.$enums.ButtonLevels.Primary,
                            text: 'Next',
                            onClick: _ctx.goToNextPage
                          }, null, 8, ["level", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_ctx.$slots['footer-' + _ctx.currentPage])
          ? _renderSlot(_ctx.$slots, 'footer-' + _ctx.currentPage, { key: 1 }, undefined, true)
          : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.$slots['header-' + _ctx.currentPage] || _ctx.headerProps)
      ? {
          name: "header",
          fn: _withCtx(() => [
            (_ctx.headerProps)
              ? (_openBlock(), _createBlock(_component_MPHDefault, _mergeProps({ key: 0 }, _ctx.headerProps, {
                  progression: _ctx.currentPage + 1,
                  maxProgression: _ctx.nbPages,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }), null, 16, ["progression", "maxProgression"]))
              : (_ctx.$slots['header-' + _ctx.currentPage])
                ? _renderSlot(_ctx.$slots, 'header-' + _ctx.currentPage, { key: 1 }, undefined, true)
                : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["visible", "transparent", "transparent-external", "external-background-color", "loading", "width", "close-on-external-click", "full-screen", "pseudo-full-screen", "max-height-content"]))
}